/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import mitt from 'mitt'
import pinia from '../store'
import idb from './idb.plugin'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import clipboard from './clipboard.plugin'
import router from '../router'
import i18nPlugin from './i18n.plugin'

pinia.use(piniaPluginPersistedstate)

export async function registerPlugins(app) {
    app.config.globalProperties.$emitter = mitt()
    app.provide('clipboard', clipboard)
    app.provide('$emitter', app.config.globalProperties.$emitter)
    app
        .use(idb)
        .use(pinia)
        .use(i18nPlugin)
        .use(router)
        .use(vuetify)
    await i18nPlugin.ready
}
